// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"4ba18869","977":"54f4e5fd"}[chunkId] + ".chunk.js";
};